//@ts-check
import * as pako from "pako"

export default async function fetchPDFFromService(payloadJSON, fileName) {

    const jsonString = JSON.stringify(payloadJSON)
    const compressed = pako.gzip(jsonString) // Uint8Array
    if (compressed === undefined) throw new Error('Zipped data is undefined')

    // test code to download the compressed file
    /* const blob2 = new Blob([compressed], { type: 'application/gzip' })
        const url2 = URL.createObjectURL(blob2);
        const a2 = document.createElement('a');
        a2.href = url2;
        a2.download = `${fileName}.json.gz`;
        a2.click();
        return
    */
   
    const blob = new Blob([compressed], { type: 'application/gzip' })
    const buffer = await blob.arrayBuffer()

    const response = await fetch(`${process.env.PDF_SERVICE_URL}/generate-pdf`, {
        method: 'POST',
        headers: {
            'Content-Encoding': 'gzip',
            'Content-Type': 'application/json'
        },
        body: buffer
    })

    if (!response.ok) {
        const serverError = new Error(`status ${response.status}`)
        serverError['response'] = response
        throw serverError
    }

    const pdfBlob = await response.blob();

    // Download the PDF
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();

    return {
        a,
        revokeURL: () => URL.revokeObjectURL(url),
    }
}